export function getSlideUrl() {
  return location.pathname.slice(1)
}
